<template>
	<div>
		<div>
			<base-radio v-for="rb in options" :key="rb.label" :name="rb.name" v-model="value.dWayTypeFromMetro" inline>{{rb.label}}</base-radio>
		</div>
		<label class="col-form-label" v-if="label != ''">{{label}}</label>
		<div class="w-100">
			<div class="form-group">
				<div class="mb-0">
					<input type="number" :placeholder="placeholder" class="form-control" v-model.lazy="value.dTimeFromMetro">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { BaseRadio } from 'src/components/index';
	export default {
		name: 'ReFromMetro',
		components: {
			BaseRadio,
		},
		props: {
			value: Object,
			placeholder: String,
			findId: {
				type: String,
				default: '',
			},
			options: Array,
			label: {
				type: String,
				default: 'Расстояние до метро',
			},
		},
		data () {
			return {
				ver: 1,
			}
		},
		computed: {

		},
		methods: {

		},
		mounted(){
			if(this.value.dWayTypeFromMetro == '') this.value.dWayTypeFromMetro = '0';
		}
	}
</script>
<style scoped>

</style>
